import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Box, Column } from 'seagull';
import { getVendorGradientStyle } from "../../../ClientOnboardingV2.utils";
import { contentTransition, contentVariants } from "../animations";
import { StepContent } from "../StepContent";
import { GetStepsContainerTID } from "./StepsContainer";
import styles from "./StepsContainerMobile.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const StepsContainerMobile = _ref => {
  let {
    testId,
    currentStep,
    direction,
    relationship
  } = _ref;
  const {
    StepsContainerTestIds
  } = useMemo(() => GetStepsContainerTID(testId), [testId]);
  const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
  return /*#__PURE__*/_jsx(Box, {
    className: styles.gradientWrapper,
    style: gradientStyle,
    "data-testid": StepsContainerTestIds.Root(),
    children: /*#__PURE__*/_jsx(Column, {
      className: styles.inner,
      children: /*#__PURE__*/_jsx(Column, {
        className: styles.content,
        "data-testid": StepsContainerTestIds.Content(),
        children: /*#__PURE__*/_jsx(AnimatePresence, {
          initial: false,
          mode: "wait",
          custom: direction,
          children: /*#__PURE__*/_jsx(motion.div, {
            custom: direction,
            variants: contentVariants,
            initial: "enter",
            animate: "center",
            exit: "exit",
            transition: contentTransition,
            children: /*#__PURE__*/_jsx(StepContent, {
              currentStep: currentStep
            })
          }, currentStep)
        })
      })
    })
  });
};